import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { api, brl, errMsg } from "@/lib/api";

const num = (v) => (v === "" || v == null ? null : Number(v));

export const AdminPrices = () => {
  const { config, loadConfig } = useApp();
  const [prices, setPrices] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/prices").then((r) => setPrices(r.data.items || {})); }, []);
  if (!prices || !config) return <Loader2 className="mx-auto h-6 w-6 animate-spin text-red-500" />;

  const set = (k, f, v) => setPrices((p) => ({ ...p, [k]: { ...(p[k] || {}), [f]: v } }));
  const save = async () => {
    setBusy(true);
    try {
      const items = Object.fromEntries(Object.entries(prices).map(([k, p]) => [k, { material: num(p.material), mao_de_obra: num(p.mao_de_obra) }]));
      await api.put("/admin/prices", { items });
      await loadConfig();
      toast.success("Preços salvos");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card-tech p-4 sm:p-6" data-testid="admin-prices">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="font-heading text-lg font-bold uppercase text-white">Tabela de preços</p>
          <p className="text-xs text-slate-500">Descrições técnicas são fixas. Itens em branco aparecem como "sob consulta" para o cliente.</p>
        </div>
        <button onClick={save} disabled={busy} className="btn-red" data-testid="admin-prices-save">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Salvar preços</button>
      </div>
      {["R", "I", "D", "P"].map((g) => (
        <div key={g} className="mb-6">
          <p className="eyebrow mb-2">{config.groups[g]}</p>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] text-sm">
              <thead><tr className="text-left font-mono text-[10px] uppercase tracking-wider text-slate-500"><th className="p-2">Cód.</th><th className="p-2">Serviço</th><th className="p-2">Material (R$)</th><th className="p-2">Mão de obra (R$)</th><th className="p-2 text-right">Preço</th></tr></thead>
              <tbody>
                {config.items.filter((i) => i.group === g).map((i) => {
                  const p = prices[i.key] || {};
                  const has = num(p.material) != null || num(p.mao_de_obra) != null;
                  return (
                    <tr key={i.key} className="border-t border-slate-800">
                      <td className="p-2 font-mono text-red-400">{i.code}</td>
                      <td className="p-2 text-slate-200">{i.nome}</td>
                      <td className="p-2"><input type="number" min="0" step="0.01" className="field !py-1.5" value={p.material ?? ""} onChange={(e) => set(i.key, "material", e.target.value)} data-testid={`price-material-${i.key}`} /></td>
                      <td className="p-2"><input type="number" min="0" step="0.01" className="field !py-1.5" value={p.mao_de_obra ?? ""} onChange={(e) => set(i.key, "mao_de_obra", e.target.value)} data-testid={`price-mao-${i.key}`} /></td>
                      <td className="p-2 text-right font-mono text-slate-200">{has ? brl((num(p.material) || 0) + (num(p.mao_de_obra) || 0)) : "Sob consulta"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};
